import React from 'react'

const Card = () => {
  return (
    <div>
        <div className="card-container">
  <div className="card">
    <img src="https://media.istockphoto.com/id/1386672296/photo/seedling-are-growing-on-coins-are-stacked-and-the-seedlings-in-concept-of-finance-and.jpg?b=1&s=170667a&w=0&k=20&c=kuhWIcTwW_dj3S0h8wtkjWdRNlJDTc8YtafoIy8czlI=" alt="Image 1"/>
    <div className="card-description">
      <h2>Card Title 1</h2>
      <p>Fidelity experts on the war in Ukraine and its far-reaching impacts.</p>
      <br />
      <a href="">Make implication</a>
    </div>
  </div>
  <div className="card">
    <img src="https://e0.pxfuel.com/wallpapers/668/776/desktop-wallpaper-investing-investor.jpg"  alt="Image 2"/>
    <div ClassName="card-description">
      <h2>Card Title 2</h2>
      <p>Fidelity's critically-acclaimed podcast takes you deep inside the workings of the Chinese economy.</p>
      <br />
      <a href="">Listen on your podcast app of choice</a>
    </div>
  </div>
  <div className="card">
    <img src="https://media.istockphoto.com/id/1311598658/photo/businessman-trading-online-stock-market-on-teblet-screen-digital-investment-concept.jpg?b=1&s=170667a&w=0&k=20&c=F4ePFhK7r539j0_I2l1Zi01SX5ESqTvu_NtqjjOUoNQ=" alt="Image 3"/>
    <div ClassName="card-description">
      <h2>Card Title 3</h2>
      <p>We are aware of scammers posing as Fidelity and offering services we do not provide in an attempt to defraud people.</p>
      <br />
      <a href="">How to keep save</a>

    </div>
  </div>
</div>

    </div>
  )
}

export default Card